<button test-id="mitId-button" data-test-id="mitId-button" (click)="click.emit()" [disabled]="busy || disabled">
	<ng-container *ngIf="!busy; else loading">
		<span class="ico-mitid-logo" *ngIf="showMitIdIcon"></span>
		<span *ngIf="label" class="text">{{ label }}</span>
	</ng-container>
	<ng-template #loading>
		<mat-spinner diameter="25"></mat-spinner>
	</ng-template>
</button>
